import React from 'react';
import { QuincenaEnVerdePage } from './pages/QuincenaEnVerdePage';
export function App() {
  return <QuincenaEnVerdePage data-id="element-0" />;
}